export const getBrowserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

const extractDateString = (dateValue) =>
  typeof dateValue === 'string' ? dateValue.split('T')[0] : new Date(dateValue).toISOString().split('T')[0]

// To remove timezone from a date string (not time)
export const formatDateOnly = (dateValue, intl, options = {}) => {
  if (!dateValue) return null
  const dateStr = extractDateString(dateValue)
  const [year, month, day] = dateStr.split('-').map(Number)
  const localDate = new Date(year, month - 1, day)
  return intl.formatDate(localDate, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  })
}

export const isToday = (dateStr) => {
  const date = new Date(dateStr)

  if (Number.isNaN(date.getTime())) {
    console.error('isToday: invalid date')
    return false
  }

  const today = new Date()

  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}

export const isTomorrow = (dateStr) => {
  const date = new Date(dateStr)

  if (Number.isNaN(date.getTime())) {
    console.error('isTomorrow: invalid date')
    return false
  }

  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)

  return (
    date.getDate() === tomorrow.getDate() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getFullYear() === tomorrow.getFullYear()
  )
}

/**
 * Converts ISO string date for it to be used in the datetime-local input (which expects a ISO like string but converted to local time)
 * https://stackoverflow.com/a/53335889
 */
export const toDateTimeLocalInput = (isoString) => {
  if (isoString == null || isoString === '') return ''
  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) return ''
  const offsetMs = date.getTimezoneOffset() * 60 * 1000
  const msLocal = date.getTime() - offsetMs
  const dateLocal = new Date(msLocal)
  const iso = dateLocal.toISOString()
  const isoLocal = iso.slice(0, 16)
  return isoLocal
}

/**
 * `datetime-local` value (browser local wall time) -> ISO-8601 UTC string (e.g. Microsoft Graph DateTimeOffset).
 */
export const datetimeLocalToGraphDateTimeOffset = (localVal) => {
  if (localVal == null || localVal === '') return undefined
  const d = new Date(localVal)
  if (Number.isNaN(d.getTime())) return undefined
  return d.toISOString()
}
